import RSVP from 'rsvp';
import _ from 'underscore';

const { Promise } = RSVP;

const _callbacks = [];
let _promises = [];

/**
 * Add a promise to the queue of callback invocation promises.
 * @param {function} callback The Store's registered callback.
 * @param {object} payload The data from the Action.
 */
const _addPromise = function (callback, payload) {
  _promises.push(
    new Promise((resolve, reject) => {
      if (callback(payload)) {
        resolve(payload);
      } else {
        reject(new Error('Dispatcher callback unsuccessful'));
      }
    })
  );
};

/**
 * Empty the queue of callback invocation promises.
 */
const _clearPromises = function () {
  _promises = [];
};

const Dispatcher = function () {};
Dispatcher.prototype = _.extend(Dispatcher.prototype, {
  /**
   * Register a Store's callback so that it may be invoked by an action.
   * @param {function} callback The callback to be registered.
   * @return {number} The index of the callback within the _callbacks array.
   */
  register(callback) {
    _callbacks.push(callback);
    return _callbacks.length - 1; // index
  },

  /**
   * dispatch
   * @param  {object} payload The data from the action.
   */
  dispatch(payload) {
    _callbacks.forEach((callback) => {
      _addPromise(callback, payload);
    });
    Promise.all(_promises).then(_clearPromises);
  },
});

export default Dispatcher;
